import { useAPIContext as e } from "./index.es46.js";
const n = () => {
  const { apiClient: t } = e();
  return t || console.warn("Failed to initialize APIClient"), { ...t };
};
export {
  n as useAPI
};
//# sourceMappingURL=index.es47.js.map
